import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import HomescreenButton from "../../components/HomescreenButton";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile,isIOS,isAndroid,isChrome,isFirefox} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SubPageTopBar from "../../components/SubPageTopBar";
//import MobileDetect from "../../components/MobileDetect";

class Stage15HomescreenButton extends React.Component {

    constructor(props){
        super(props);
    }


    /**
     * render
     * @returns {*}
     */
    render() {

        const homescreenButtonContent = <div>
            <Header
                textResource={"homescreenButton_title"}
            />
            <SpacerRow/>
            <TextBody
                textResource={"homescreenButton_bodytext"}
            />
        </div>


        /**
         * Add to bookmark
         * Several tests are necessary in order for this "simple" action to work in most of the browsers
         * Working in some older desktop browsers but in no mobile browser
         */
        const addBookmark = () => {

            // console.log( "FNX: addBookmark" );

            if( isMobile ) {

                // console.log( "FNX: addBookmark // Mobile // not supported" );

                if(isAndroid){
                    alert("Damit du diese Seite später schneller wiederfindest, speichere sie einfach ab. Öffne dazu deine Browser Einstellungen und klicke auf den Stern.");
                }else if(isIOS){
                    alert("Damit du diese Seite später schneller wiederfindest, speichere sie einfach ab. Wähle hierzu die Funktion 'Teilen' und 'Zur Leseliste hinzufügen'.");
                }

            } else {

                // console.log( "FNX: addBookmark // Desktop" );

                if (window.sidebar && window.sidebar.addPanel) { // Firefox <23

                    // console.log( "FNX: addBookmark // FF <23" );
                    window.sidebar.addPanel(document.title,window.location.href,'');

                } else if(window.external && ('AddFavorite' in window.external)) { // Internet Explorer <= 7

                    // console.log( "FNX: addBookmark // IE <=7" );
                    window.external.AddFavorite(window.location.href,document.title);

                } else if(window.external && ('AddToFavoritesBar' in window.external)) { // Internet Explorer >= 8

                    // console.log( "FNX: addBookmark // IE >=8" );
                    window.external.AddToFavoritesBar(window.location.href,document.title);

                } else if(window.opera && window.print || window.sidebar && ! (window.sidebar instanceof Node)) { // Opera <15 and Firefox >23

                    // console.log( "FNX: addBookmark // Opera <15 and Firefox >23" );
                    /**
                     * For Firefox <23 and Opera <15, no need for JS to add to bookmarks
                     * The only thing needed is a `title` and a `rel="sidebar"`
                     * To ensure that the bookmarked URL doesn't have a complementary `#` from our trigger's href
                     * we force the current URL
                     */
                    var elem = document.createElement('a');
                    elem.setAttribute('href',window.location.href);
                    elem.setAttribute('title',document.title);
                    elem.setAttribute('rel','sidebar');
                    elem.click();
                    // elem.parentNode.removeChild(elem);

                } else { // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D

                    // console.log( "FNX: addBookmark // not supported" );
                    alert('Bitte drücken Sie die Tastenkombination ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'STRG') + ' + D auf Ihrer Tastatur, um ein Lesezeichen hinzuzufügen.');

                }

            }

        };



        /**
         * add to homescreen function only possible via PWA
         * references e.g.
         * - https://developer.mozilla.org/en-US/docs/Web/Progressive_web_apps/Add_to_home_screen
         */
        const addToHomescreen = () => {

            // console.log( "FNX: addToHomescreen" );

            if( window.addToHomeScreenEvent ) {

                // console.log( "FNX: addToHomescreen // window.addToHomeScreenEvent" );

                window.addToHomeScreenEvent.prompt();

                // Wait for the user to respond to the prompt
                window.addToHomeScreenEvent.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        // console.log('User accepted the A2HS prompt');
                    } else {
                        // console.log('User dismissed the A2HS prompt');
                    }
                    window.addToHomeScreenEvent = null;
                });

            } else {

                // console.log( "FNX: addToHomescreen // NO window.addToHomeScreenEvent" );

                if(isMobile){
                    if(isAndroid){
                        alert("Damit du nie wieder suchen musst, lege diese Seite auf deinem Home-Bildschirm ab. Öffne dazu deine Browser Einstellungen und wähle 'Zu Startbildschirm hinzufügen'.");
                    }else if(isIOS){
                        alert("Damit du nie wieder suchen musst, lege diese Seite auf deinem Home-Bildschirm ab. Wähle hierzu die Funktion 'Teilen' und anschließend 'Zum Home-Bildschirm'.");
                    }
                }
            }

        };


        /**
         * copy link function
         * iOS needs special handling
         */
        const copyLink = () => {

            // console.log( "FNX: copyLink" );

            // special handling for iOS devices
            if( isIOS ) {

                // console.log( "FNX: iOS" );

                var editable = this.locationInput.contentEditable;
                var readOnly = this.locationInput.readOnly;

                this.locationInput.contentEditable = true;
                this.locationInput.readOnly = false;

                var range = document.createRange();
                range.selectNodeContents(this.locationInput);

                var selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                this.locationInput.setSelectionRange(0, 999999);
                this.locationInput.contentEditable = editable;
                this.locationInput.readOnly = readOnly;

            } else {

                this.locationInput.select();

            }

            try {

                // Now that we've selected the anchor text, execute the copy command
                var successful = document.execCommand('copy', false, null);
                var msg = successful ? 'successful' : 'unsuccessful';

                if(true){
                    // $this.addClass("copied").html("Copied");
                    // console.log('Copied successful');
                }

            } catch(err) {
                // console.log('Oops, unable to copy');
            }

            // Remove the selections - NOTE: Should use removeRange(range) when it is supported
            window.getSelection().removeAllRanges();

        };


        return <Container>

            <MobileView>
                <SubPageTopBar
                        progress={0}
                        onClickClose={this.props.onClickClose}
                />
                <Col xs={2} style={{paddingTop:"20vh"}}></Col>
                {homescreenButtonContent}
                <Col xs={'12'} className={"homescreen"}>
                    <BottomBar
                        showHomescreenButtons={true}
                        showFullWidth={true}
                        mainButtonOnClick={() => {
                            this.props.validationCallback(0);
                        }}
                        homescreenButtonBookmarkTextResource={"homescreen_button_bookmark"}
                        homescreenButtonBookmarkOnClick={addBookmark}
                        homescreenButtonHomescreenTextResource={"homescreen_button_homescreen"}
                        homescreenButtonHomescreenOnClick={addToHomescreen}
                        homescreenButtonCopyTextResource={"homescreen_button_copy"}
                        homescreenButtonCopyOnClick={copyLink}
                    />
                </Col>
                <form>
                    <input
                        ref={(locationInput) => this.locationInput = locationInput}
                        value={window.location}
                        id={"current-url-input"}
                        readOnly={true}
                        contentEditable={false}
                        className={"copy-input-hidden"}
                    />
                </form>
            </MobileView>

            <BrowserView>
                <SubPageTopBar
                    progress={0}
                    onClickClose={this.props.onClickClose}
                />
                <Col xs={2} style={{paddingTop:"20vh"}}></Col>
                    <Col xs={'12'} className={"homescreen"}>
                    {homescreenButtonContent}
                    <BottomBar
                        showHomescreenButtons={true}
                        showFullWidth={true}
                        mainButtonOnClick={() => {
                            this.props.validationCallback(0);
                        }}
                        homescreenButtonBookmarkTextResource={"homescreen_button_bookmark"}
                        homescreenButtonBookmarkOnClick={addBookmark}
                        homescreenButtonHomescreenTextResource={"homescreen_button_homescreen"}
                        homescreenButtonHomescreenOnClick={addToHomescreen}
                        homescreenButtonCopyTextResource={"homescreen_button_copy"}
                        homescreenButtonCopyOnClick={copyLink}
                    />
                </Col>
                <form>
                    <input
                        ref={(locationInput) => this.locationInput = locationInput}
                        value={window.location}
                        id={"current-url-input"}
                        readOnly={true}
                        contentEditable={false}
                        className={"copy-input-hidden"}
                    />
                </form>
            </BrowserView>

        </Container>
    }
}

export default translate("translations")(Stage15HomescreenButton);